import { render } from "./News8.vue?vue&type=template&id=2a9a8b3d"
import script from "./News8.vue?vue&type=script&lang=js"
export * from "./News8.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__